import Rest from '../rest';
import APPLICATION_CONSTANTS from '../applicationConstants';

class BaiduSearchAutocompleteService {
  getSuggestions = input => {
    const apiKey = '5LIL44N8YdmRYuNTe8ssGLLq';
    const url = `${APPLICATION_CONSTANTS.GLOBAL.API_URL}/Practice/baiduSearchSuggestions?query=${input}&region=Beijing&city_limit=false&output=json&ak=${apiKey}`;

    return new Promise((resolve, reject) => {
      Rest.get(url, { timeout: process.env.LOCATOR_API_TIMEOUT })
        .then(({ data }) => resolve(data?.result))
        .catch(error => reject(error));
    });
  };
}

export default BaiduSearchAutocompleteService;
